<template>
  <div class="tnc-box">
    <div class="tnc-box__title-bar">
      <a-row
        align="middle"
        type="flex"
        justify="space-between"
      >
        <a-col :span="12">
          <HKLGrayHintVue>
            {{ lastUpdatedBy }}
          </HKLGrayHintVue>
        </a-col>
        <a-col
          v-if="canEdit"
          :span="12"
        >
          <a-row
            type="flex"
            justify="end"
            class="tnc-box__buttons"
          >
            <HKLUploadButton
              v-if="!isEditing"
              @importFile="importJson"
            />
            <HKLButton
              v-if="!isEditing "
              color="orange"
              action="export"
              @click="exportJson"
            />

            <HKLButton
              v-if="!isEditing"
              color="orange"
              action="edit"
              @click="edit"
            />
            <HKLButton
              v-if="isEditing"
              color="darkblue"
              action="cancel"
              @click="cancel"
            />
            <HKLButton
              v-if="isEditing"
              color="orange"
              action="save"
              @click="save"
            />
          </a-row>
        </a-col>
      </a-row>
    </div>

    <CommonTNC
      ref="commonTNCRef"
      class="tnc-box__collapse"
    />

    <TenancyRecordTNC
      ref="trTNCRef"
      class="tnc-box__collapse"
    />

    <HotbTNC
      ref="hotbTNCRef"
      class="tnc-box__collapse"
    />
    <TenantProjectTNC
      ref="tpTNCRef"
      class="tnc-box__collapse"
    />
    <DirectoryTNC
      ref="directoryTNCRef"
      class="tnc-box__collapse"
    />

    <WorkPermitTNC
      ref="wpTNCRef"
      class="tnc-box__collapse"
    />
    <ItqTenderTNC
      ref="tenderTNCRef"
      class="tnc-box__collapse"
    />
  </div>
</template>

<script>
import { saveRegionLocalization } from '@/api/localization/request'
import { exportContent } from '@/api/settings/request'
import HKLButton from '@/controls/Button/HKLButton.vue'
import HKLUploadButton from '@/controls/Button/HKLUploadButton'
import HKLGrayHintVue from '@/controls/HKLGrayHint.vue'
import { useStoreGetters } from '@/store'
import { aclHelper, aclPermsType } from '@/utils/aclHelper'
import i18n, { loadLanguageAsync } from '@/utils/i18n'
import lodash from 'lodash'
import { computed, provide, ref, unref } from 'vue-demi'
import CommonTNC from './CommonTNC.vue'
import DirectoryTNC from './DirectoryTNC.vue'
import HotbTNC from './HotbTNC.vue'
import ItqTenderTNC from './ItqTenderTNC.vue'
import TenancyRecordTNC from './TenancyRecordTNC.vue'
import TenantProjectTNC from './TenantProjectTNC.vue'
import WorkPermitTNC from './WorkPermitTNC.vue'
import { I18N_CONFIG_NAME, TNC_EDITING_PROVIDE } from './consts'
import { useI18nDataQuery } from './hook'
import { getLastUpdatedByOn } from './utils'

export default {
  components: {
    HKLButton,
    HKLGrayHintVue,
    CommonTNC,
    ItqTenderTNC,
    TenancyRecordTNC,
    TenantProjectTNC,
    HotbTNC,
    WorkPermitTNC,
    DirectoryTNC,
    HKLUploadButton,
  },
  setup () {
    const isEditing = ref(false)
    provide(TNC_EDITING_PROVIDE, isEditing)
    const { currentRegion } = useStoreGetters('regions', ['currentRegion'])
    const { data: responseData, refresh } = useI18nDataQuery()
    const { currentLanguage } = useStoreGetters('language', ['currentLanguage'])

    const regionI18n = ref([])
    const commonTNCRef = ref(null)
    const tenderTNCRef = ref(null)
    const trTNCRef = ref(null)
    const tpTNCRef = ref(null)
    const hotbTNCRef = ref(null)
    const wpTNCRef = ref(null)
    const directoryTNCRef = ref(null)
    const lastUpdatedBy = computed(() => {
      const history = unref(responseData).history || {}
      return getLastUpdatedByOn(history)
    })
    const listRef = computed(() => {
      return [
        commonTNCRef,
        trTNCRef,
        hotbTNCRef,
        tpTNCRef,
        directoryTNCRef,
        wpTNCRef,
        tenderTNCRef,
      ]
    })
    const importJson = (result) => {
      const language = unref(currentLanguage)
      const regionName = unref(currentRegion).name
      unref(listRef).map((listByModule) => {
        const basicPath = `i18nPendingFields.${language}`
        const module = lodash.get(unref(listByModule), 'i18nCategory')
        const path = basicPath.concat(`.${module}`)
        const moduleName = `${i18n.t(`settings.regionConfig.moduleTitle.${module}`)}`

        const pendingFieldsByLangModule = lodash.get(unref(listByModule), path)
        const toUpdateContent = result[moduleName]

        if (pendingFieldsByLangModule) {
          pendingFieldsByLangModule.forEach((bodyObj, index) => {
            const i18nConfigContent = bodyObj[I18N_CONFIG_NAME]
            const i18nLabel = i18n.t(i18nConfigContent.label)

            const detail = lodash.get(toUpdateContent, [i18nLabel], '')
            bodyObj[regionName] = detail
          })
        }
      })

      isEditing.value = true
    }

    const exportJson = async () => {
      const content = unref(listRef).reduce((result, val, index) => {
        const parseI8nDataArray = lodash.get(unref(val), 'parsedI18nData')
        const module = lodash.get(unref(val), 'i18nCategory')
        const moduleName = `${i18n.t(`settings.regionConfig.moduleTitle.${module}`)}`

        if (!result[moduleName]) {
          lodash.set(result, [moduleName], {})
        }

        parseI8nDataArray.map(detail => {
          let valueByLanguage = detail[unref(currentLanguage)] || ''
          const label = detail.label

          Object.assign(result[moduleName], { [label]: valueByLanguage })
        })

        return result
      }, {})
      const filename = `${i18n.t('settings.regionConfig.termsWithoutSlash')}_${unref(currentRegion).name}.json`

      const request = { filename, content }
      await exportContent(request)
    }
    return {
      isEditing,
      lastUpdatedBy,
      commonTNCRef,
      tenderTNCRef,
      trTNCRef,
      tpTNCRef,
      hotbTNCRef,
      wpTNCRef,
      directoryTNCRef,
      regionJson: regionI18n,
      exportJson,
      importJson,
      canEdit: computed(() => {
        return aclHelper.getAccess(aclPermsType.settings.updateRegional)
      }),
      edit: () => { isEditing.value = true },
      cancel: () => { isEditing.value = false },
      save: async () => {
        const payload = lodash.merge.apply(null,
          unref(listRef).map(refVar => unref(refVar).getFieldValues()),
        )
        await saveRegionLocalization(unref(currentRegion).name, {
          ...payload,
          language: unref(currentLanguage),
        })
        await refresh()
        await loadLanguageAsync(unref(currentLanguage), { force: true })
        isEditing.value = false
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.tnc-box {
  &__title-bar {
    margin-bottom: 10px;
  }
  &__buttons button{
    margin-left: 10px;
  }
  &__collapse {
    margin-bottom: 20px;
  }
}
</style>
